import { cloneDeep } from 'lodash';

const columnSettings = {
  name: {
    name: 'name',
    sort: 'asc',
    defaultSort: 'asc',
    displayName: 'TABLE_HEADER_COL_NAME',
  },
  email: {
    name: 'email',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_EMAIL',
  },
  role: {
    name: 'role',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_ROLE'
  },
  invite: {
    name: 'invite',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_INVITATION'
  },
  canExportReport: {
    name: 'canExportReport',
    class: 'text-center',
    sort: 'asc',
    displayName: 'TABLE_HEADER_COL_CAN_EXPORT',
  },
};

const defaultColumns = ['name', 'email', 'role', 'invite', 'canExportReport'];

export default class AccountUserService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.columnSettings = cloneDeep(columnSettings);
    this.defaultColumns = [...defaultColumns];
  }

  getAccountUsers(accountId) {
    const url = this.#getBaseUrl(accountId) + '?includeAllRoles=true';
    return this.$http.get(url).then((response) => {
      const users = response.data.users.map((user) => {
        user.name = user.firstName + ' ' + user.lastName;
        return user;
      });
      return users;
    });
  }

  getAuthenticationType() {
    const url = this.ngAuthSettings.apiServiceBaseUri + 'profile/getAuthenticationType';
    return this.$http.get(url);
  }

  createAccountUser(accountId, user) {
    const url = this.#getBaseUrl(accountId);
    return this.$http.put(url, user);
  }

  deleteAccountUser(accountId, userId) {
    const url = this.#getBaseUrl(accountId, userId);
    return this.$http.delete(url);
  }

  #getBaseUrl(accountId, userId) {
    return this.ngAuthSettings.apiServiceBaseUri + 'ringbaaccounts/' + accountId + '/users' + (userId ? '/' + userId : '');
  }
}